import CookieUtils, { CookieName } from 'chairisher/util/cookie';

const ChairishContext = window.chairisher.context;

/**
 * @returns {string} Returns URL for SMS subscription
 */
export function getAttentiveSmsSubscribeUrl() {
    return ChairishContext.SMS_SUBSCRIBE_PATH;
}

/**
 * @returns {string} Returns URL for tel utils script
 */
export function getIntlTelUtilPath() {
    return ChairishContext.TEL_UTIL_PATH;
}

/**
 * @returns {boolean} Returns boolean based on context or cookie state
 */
export function hasSubmittedSmsData() {
    return ChairishContext.HAS_SMS_DATA || !!CookieUtils.getValueFromCookie(CookieName.ATTENTIVE_SMS_SUBMITTED);
}
